export default __webpack_public_path__ + "static/media/EmergencySensor.536170a0.png";